'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { getMobileAppUrl, getMobileStorePlatform, getMobileStoreUrl, type MobileStorePlatform } from '@/components/mobile-browser-store-banner';
export function WebSunsetGate(t0) {
  const $ = _c(31);
  const {
    onAccess
  } = t0;
  const [platform, setPlatform] = useState(null);
  const [hasDetectedPlatform, setHasDetectedPlatform] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const detectedPlatform = getMobileStorePlatform({
        userAgent: window.navigator.userAgent,
        maxTouchPoints: window.navigator.maxTouchPoints,
        platform: window.navigator.platform
      });
      setPlatform(detectedPlatform);
      setHasDetectedPlatform(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const isAndroid = platform === "android";
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute left-0 top-0 h-[262px] w-full overflow-hidden"><img src="/images/web-sunset-modal-mobile.webp" alt="" fetchPriority="high" decoding="async" className="size-full object-cover object-center" /></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex w-full flex-col items-center gap-2"><h1 className="w-full text-2xl font-medium leading-8">Tem mais esperando por você no app</h1><p className="w-[306px] text-base font-normal leading-6 text-zinc-400">A versão web foi encerrada para concentrarmos a experiência do Pierre onde ela é mais completa. Com recursos, personalizações e novidades</p></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== hasDetectedPlatform || $[5] !== isAndroid || $[6] !== platform) {
    t5 = hasDetectedPlatform && platform && <a href={getMobileStoreUrl(platform)} target="_blank" rel="noreferrer" aria-label={isAndroid ? "Baixar na Google Play" : "Baixar na App Store"} className="relative block h-10"><Image src={isAndroid ? "/images/google-play-badge.webp" : "/images/web-sunset-app-store-badge.png"} alt="" width={isAndroid ? 135 : 120} height={40} priority={true} /></a>;
    $[4] = hasDetectedPlatform;
    $[5] = isAndroid;
    $[6] = platform;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== hasDetectedPlatform || $[9] !== platform) {
    t6 = hasDetectedPlatform && !platform && <div data-testid="web-sunset-mobile-qr" className="flex size-40 items-center justify-center overflow-hidden rounded-[18px] bg-zinc-50"><Image src="/images/web-sunset-gate-qr-code.svg" alt="" width={150} height={147} priority={true} /></div>;
    $[8] = hasDetectedPlatform;
    $[9] = platform;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="absolute left-1/2 top-[298px] flex w-[330px] -translate-x-1/2 flex-col items-center gap-6 text-center">{t4}{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== hasDetectedPlatform || $[15] !== platform) {
    t8 = hasDetectedPlatform && platform && <a href={getMobileAppUrl(platform)} className="absolute bottom-[27px] left-4 right-4 flex h-14 items-center justify-center rounded-full bg-[#cfff04] text-base font-medium leading-6 text-black transition-colors hover:bg-[#baf000] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#cfff04] focus-visible:ring-offset-2 focus-visible:ring-offset-[#09090b]">Terminar no aplicativo</a>;
    $[14] = hasDetectedPlatform;
    $[15] = platform;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <section data-testid="web-sunset-mobile-layout" className="relative h-full w-full lg:hidden">{t3}{t7}{t8}</section>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex size-[160px] shrink-0 items-center justify-center overflow-hidden rounded-[18px] bg-zinc-50 lg:size-[190px] lg:rounded-[21px] xl:size-[215px] xl:rounded-3xl"><Image src="/images/web-sunset-gate-qr-code.svg" alt="QR Code para baixar o aplicativo Pierre" width={202} height={198} priority={true} fetchPriority="high" className="h-[92.093%] w-[93.953%]" /></div>;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <h1 className="text-3xl font-medium leading-9 lg:text-4xl lg:leading-10 xl:text-5xl xl:leading-none">Tem mais esperando por você no app</h1>;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="space-y-6 text-base font-normal leading-6 text-zinc-400 xl:text-lg"><p>A versão web foi encerrada para concentrarmos a experiência do Pierre onde ela é mais completa. Com recursos, personalizações e novidades.</p><p>Escaneie o QR Code ou baixe o aplicativo para acessar sua conta, acompanhar suas finanças e aproveitar todos os recursos do Pierre.</p></div>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== onAccess) {
    t13 = <div className="absolute bottom-0 left-[clamp(32px,7.2222vw,104px)] right-[calc(50%+clamp(32px,5.9028vw,85px))] top-0 flex min-w-0 items-center"><div className="-mt-[7px] flex w-full max-w-[531px] flex-col items-start gap-8 xl:gap-11">{t10}<div className="flex w-full flex-col gap-4">{t11}{t12}<button type="button" onClick={onAccess} className="flex h-12 w-40 items-center justify-center rounded-full border border-zinc-600 text-base font-medium text-white transition-colors hover:bg-zinc-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#cfff04]">Acessar</button></div></div></div>;
    $[23] = onAccess;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div data-testid="web-sunset-desktop-image" className="absolute bottom-[3.6133%] right-[clamp(32px,5.9028vw,85px)] top-[2.832%] w-[min(47.43vw,683px)] overflow-hidden rounded-[32px]"><img src="/images/web-sunset-gate-desktop.webp" alt="" fetchPriority="high" decoding="async" className="absolute inset-0 size-full object-cover object-center" /></div>;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t13) {
    t15 = <section data-testid="web-sunset-desktop-layout" className="relative hidden h-full w-full lg:block">{t13}{t14}</section>;
    $[26] = t13;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15 || $[29] !== t9) {
    t16 = <main className="relative h-dvh min-h-[600px] overflow-hidden bg-[#09090b] text-white">{t9}{t15}</main>;
    $[28] = t15;
    $[29] = t9;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
}